export const EDITOR_ACTIONS = {
  SET_EDIT: 'setEdit',
  SET_RENAME: 'setRename',
  SET_DELETE: 'setDelete',
  SET_REPLACE: 'setReplace',
  RESET: 'reset',
  UPDATE: 'update',
  CHANGE: 'change',
  IMAGE_UPLOAD: 'imageUpload',
  IMAGE_UPLOAD_SUCCESS: 'imageUploadSuccess',
  IMAGE_UPLOAD_FAIL: 'imageUploadFail',
  ERROR: 'error'
} as const

export type EditorActionsType = (typeof EDITOR_ACTIONS)[keyof typeof EDITOR_ACTIONS]
